// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"42":"23767c58","53":"fdafd4a9","64":"940ad3a9","215":"cb9c5101","409":"3b565393","422":"b627c6e2","424":"0887327e","463":"ada1e663","516":"174ee6ed","736":"0fc3aadd","775":"dfec1304","939":"c146cbb7"}[chunkId] + ".chunk.js";
};